import { Button, Container, styled, Typography } from '@mui/material';
import { m } from 'framer-motion';
import Page from 'src/components/Page';

import { MotionContainer, varBounce } from 'src/components/animate';
import { SeverErrorIllustration } from 'src/assets';
import { PATH_DASHBOARD } from 'src/routes/paths';

//
//

export const GenericErrorPage = () => {
  const goToHomePage = () => {
    return (window.location.href = PATH_DASHBOARD.root);
  };

  //

  return (
    <StyledPage title="">
      <Container component={MotionContainer}>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <m.div variants={varBounce().in}>
            <Typography variant="h4" paragraph>
              Unfortunately, an error has occurred.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>
              Our support team has already been notified, and we are working on this issue.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <StyledIllustration />
          </m.div>

          <Button variant="contained" onClick={goToHomePage}>
            Go to home
          </Button>
        </StyledContent>
      </Container>
    </StyledPage>
  );
};

//

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(10, 0),
}));

const StyledPage = styled(Page)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}));

const StyledIllustration = styled(SeverErrorIllustration)(({ theme }) => ({
  height: 200,
  [theme.breakpoints.up('xs')]: {
    margin: theme.spacing(5, 0),
  },
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(10, 0),
  }
}));